import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { publicAPI } from '../services/api';

const PublicAnswer = () => {
  const { shortId } = useParams();
  const [answer, setAnswer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!shortId || hasFetched.current) return;

    const fetchAnswer = async () => {
      try {
        hasFetched.current = true;
        const response = await publicAPI.getAnswer(shortId);
        setAnswer(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch answer:', error);
        setError(error.response?.data?.error || 'Cevap yüklenemedi');
        setLoading(false);
      }
    };

    fetchAnswer();

    // Reset on unmount for next visit
    return () => {
      hasFetched.current = false;
    };
  }, [shortId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-red-600 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Hata</h2>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo and School Name */}
        <div className="text-center mb-6">
          <img
            src="/img/logo200px.png"
            alt="Ankara Dil Akademisi Logo"
            className="mx-auto mb-2 h-20"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h2 className="text-xl font-bold text-gray-800">Ankara Dil Akademisi</h2>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-blue-600 px-6 py-4">
            <h1 className="text-xl font-bold text-white">Cevap Detayı</h1>
          </div>

          <div className="p-6 space-y-6">
            {answer.questionText && (
              <div>
                <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Soru</h2>
                <p className="mt-2 text-gray-900">{answer.questionText}</p>
              </div>
            )}

            <div>
              <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Doğru Cevap</h2>
              <div className="mt-2 flex items-center">
                <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-green-100 text-green-800 text-xl font-bold">
                  {answer.answerChoice}
                </span>
              </div>
            </div>

            <div>
              <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Açıklama</h2>
              <p className="mt-2 text-gray-900 whitespace-pre-wrap">{answer.explanation}</p>
            </div>

            <div className="border-t pt-6">
              <div className="flex justify-between text-sm text-gray-500">
                {/*<div>*/}
                {/*  <span className="font-medium">Öğretmen:</span> {answer.teacherName}*/}
                {/*</div>*/}
                {/*<div>*/}
                {/*  <span className="font-medium">Görüntülenme:</span> {answer.viewCount}*/}
                {/*</div>*/}
              </div>
              {/*<div className="mt-2 text-sm text-gray-500">*/}
              {/*  <span className="font-medium">Tarih:</span> {new Date(answer.createdAt).toLocaleDateString('tr-TR')}*/}
              {/*</div>*/}
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            ADA QR Cevap Sistemi tarafından sağlanmıştır
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicAnswer;
